import { type ForwardedRef, forwardRef, memo } from "react";

import { CartBase } from "@cart/CartBase";
import { tw } from "classnames";

type Props = Record<string, never>;

const styles = {
  cartDrawer: tw(
    "relative",
    "h-screen",
    "max-h-dynamic-screen",
    "w-screen",
    "bg-background-secondary",
    "md:w-sidebar"
  ),
};

const CartDrawerViewBase = (_: Props, ref: ForwardedRef<HTMLDivElement>) => {
  return (
    <div className={styles.cartDrawer} data-testid="cartDrawer" ref={ref}>
      <CartBase />
    </div>
  );
};

export const CartDrawerView = memo(forwardRef(CartDrawerViewBase));
